import { render } from "./Healing.vue?vue&type=template&id=6c4f8036"
import script from "./Healing.vue?vue&type=script&lang=js"
export * from "./Healing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Healing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c4f8036"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c4f8036', __exports__)) {
    api.reload('6c4f8036', __exports__)
  }
  
  module.hot.accept("./Healing.vue?vue&type=template&id=6c4f8036", () => {
    api.rerender('6c4f8036', render)
  })

}


export default __exports__